import { Observable } from 'rxjs';
import { BranchIntParams } from '../models/branch-international.model';
import {
    AvailabilityInternationalResponse,
    BranchInternationalResponse,
} from '../models/branch-international-response.model';

export abstract class BranchesInternationalRepository {
    abstract findBranchesInternational(
        BranchParams: BranchIntParams,
    ): Observable<BranchInternationalResponse>;

    abstract getAvailabilityInternational(
        BranchParams: BranchIntParams,
    ): Observable<AvailabilityInternationalResponse>;

    abstract clearLocationInt(): Observable<boolean>;

    abstract saveLocationInt(parmas: BranchIntParams): Observable<boolean>;
}
